import {Injectable} from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetalertService {

  successAttendance(): void {
    Swal.fire({
      icon: "success",
      title: `Attendance Completed. Thank You!`,
      showConfirmButton: false,
      timer: 3000
    });
  }



  successMessage(message: string): void {
    Swal.fire({
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 3000
    });
  }

  failMessage(message: string): void {
    Swal.fire({
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000
    });
  }

  failedAttendance(message: string): void {
    Swal.fire({
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000
    });
  }

  validationFailed(message: string): void {
    Swal.fire({
      icon: 'error',
      title: message,
      confirmButtonText: 'OK',
      showConfirmButton: true
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  }

  errorInValidationInfo(error: any, title: string) {
    const dataMessages = error.data
      ? Object.values(error.data)
        .map((message, index) =>
          `<div style="text-align: start; width: 325px;">
                    <strong>${index + 1}.</strong> ${message}
                </div>`
        )
        .join("")
      : "";

    Swal.fire({
      icon: "error",
      title: title,
      html: `
            <div>${error.message}</div>
            ${dataMessages ? `
            <div style="width: 100%;
    max-height: 150px;overflow-y: auto;margin-top: 10px;padding: 10px;display: flex;flex-direction: column;align-items: center;">
                ${dataMessages}
            </div>` : ""}
        `, // Add scrollable container for dataMessages
      showConfirmButton: true,
    });
  }

  errorInInfo(error: any, title?: string) {
    Swal.fire({
      icon: "error",
      title: title ? title : 'Error',
      html: error,
      showConfirmButton: true,
      customClass: {
        popup: 'custom-swal-popup' // Add this line to assign a custom class
      }
    });
  }

  autoClose(error: any, title?: string,icon?:any) {
    Swal.fire({
      icon: icon,
      title: title ? title : 'Error',
      html: error,
      timer: 5000,
      timerProgressBar: true,
      showConfirmButton: false,
      customClass: {
        popup: 'custom-swal-popup'
      }
    });
  }

  loginError(title: string, msg: any) {
    Swal.fire({
      icon: "error",
      title: title + "!",
      text: msg,
      showConfirmButton: true,
    });
  }

  deleteConfirmation(message?: string,): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'me-2 btn btn-danger'
        },
        buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
        title: 'Are you sure?',
        text: message != undefined ? message : "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No!',
      }).then((result) => {
        resolve(result.isConfirmed)
      });
    })
  }

  alertWithOK(title:any,message:any,icon:any){
    Swal.fire({
      icon: icon,
      title: title + "!",
      text: message,
      showConfirmButton: true,
    });
  }

  alertWithOkAndCancle(title:any,message:any,icon:any){
    return new Promise<boolean>(resolve => {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'me-2 btn btn-danger'
        },
        buttonsStyling: false
      })
      swalWithBootstrapButtons.fire({
        title: title,
        text: message,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        resolve(result.isConfirmed)
      });
    })
  }

}
